"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowVersionstateEnumType = exports.WorkflowType = exports.VasTaskInputStatusTypeEnum = exports.TradeinSourceCommerce = exports.TrackedEventappNameEnumType = exports.SimTransferTypeEnum = exports.SimOrderStageTypeEnum = exports.SignInMethodPublic = exports.ReturnItemState = exports.PricingAdjustmentStagingItemvalidationStatusEnumType = exports.OmitMeasurementsOptionPrivate = exports.OmitMeasurementsOptionAdmin = exports.ImageOptionsPresetType = exports.ColorHueEnumTypeAdmin = exports.CatalogItemMeasurementFieldPurposeRestUser = exports.CatalogItemMeasurementFieldPurposePublic = exports.CatalogItemMeasurementFieldPurposePrivate = exports.CatalogItemMeasurementFieldPurposeAdmin = exports.BulkPrintLabelType = void 0;
var BulkPrintLabelType;
(function (BulkPrintLabelType) {
    BulkPrintLabelType["Hangtag"] = "HANGTAG";
    BulkPrintLabelType["TroveLpn"] = "TROVE_LPN";
})(BulkPrintLabelType || (exports.BulkPrintLabelType = BulkPrintLabelType = {}));
var CatalogItemMeasurementFieldPurposeAdmin;
(function (CatalogItemMeasurementFieldPurposeAdmin) {
    /** Load all measurement fields configured for use by check-in associates when checking in new instances of this catalog item. */
    CatalogItemMeasurementFieldPurposeAdmin["Checkin"] = "CHECKIN";
    /** Load all configured measurement fields for this catalog item. */
    CatalogItemMeasurementFieldPurposeAdmin["General"] = "GENERAL";
    /** Load all measurement fields for this catalog item that are configured for display to customers. */
    CatalogItemMeasurementFieldPurposeAdmin["Shop"] = "SHOP";
})(CatalogItemMeasurementFieldPurposeAdmin || (exports.CatalogItemMeasurementFieldPurposeAdmin = CatalogItemMeasurementFieldPurposeAdmin = {}));
var CatalogItemMeasurementFieldPurposePrivate;
(function (CatalogItemMeasurementFieldPurposePrivate) {
    /** Load all measurement fields configured for use by check-in associates when checking in new instances of this catalog item. */
    CatalogItemMeasurementFieldPurposePrivate["Checkin"] = "CHECKIN";
    /** Load all configured measurement fields for this catalog item. */
    CatalogItemMeasurementFieldPurposePrivate["General"] = "GENERAL";
    /** Load all measurement fields for this catalog item that are configured for display to customers. */
    CatalogItemMeasurementFieldPurposePrivate["Shop"] = "SHOP";
})(CatalogItemMeasurementFieldPurposePrivate || (exports.CatalogItemMeasurementFieldPurposePrivate = CatalogItemMeasurementFieldPurposePrivate = {}));
var CatalogItemMeasurementFieldPurposePublic;
(function (CatalogItemMeasurementFieldPurposePublic) {
    /** Load all measurement fields configured for use by check-in associates when checking in new instances of this catalog item. */
    CatalogItemMeasurementFieldPurposePublic["Checkin"] = "CHECKIN";
    /** Load all configured measurement fields for this catalog item. */
    CatalogItemMeasurementFieldPurposePublic["General"] = "GENERAL";
    /** Load all measurement fields for this catalog item that are configured for display to customers. */
    CatalogItemMeasurementFieldPurposePublic["Shop"] = "SHOP";
})(CatalogItemMeasurementFieldPurposePublic || (exports.CatalogItemMeasurementFieldPurposePublic = CatalogItemMeasurementFieldPurposePublic = {}));
var CatalogItemMeasurementFieldPurposeRestUser;
(function (CatalogItemMeasurementFieldPurposeRestUser) {
    /** Load all measurement fields configured for use by check-in associates when checking in new instances of this catalog item. */
    CatalogItemMeasurementFieldPurposeRestUser["Checkin"] = "CHECKIN";
    /** Load all configured measurement fields for this catalog item. */
    CatalogItemMeasurementFieldPurposeRestUser["General"] = "GENERAL";
    /** Load all measurement fields for this catalog item that are configured for display to customers. */
    CatalogItemMeasurementFieldPurposeRestUser["Shop"] = "SHOP";
})(CatalogItemMeasurementFieldPurposeRestUser || (exports.CatalogItemMeasurementFieldPurposeRestUser = CatalogItemMeasurementFieldPurposeRestUser = {}));
var ColorHueEnumTypeAdmin;
(function (ColorHueEnumTypeAdmin) {
    ColorHueEnumTypeAdmin["BluePurple"] = "BLUE_PURPLE";
    ColorHueEnumTypeAdmin["GreenYellow"] = "GREEN_YELLOW";
    ColorHueEnumTypeAdmin["Neutral"] = "NEUTRAL";
    ColorHueEnumTypeAdmin["Other"] = "OTHER";
    ColorHueEnumTypeAdmin["RedOrange"] = "RED_ORANGE";
})(ColorHueEnumTypeAdmin || (exports.ColorHueEnumTypeAdmin = ColorHueEnumTypeAdmin = {}));
var ImageOptionsPresetType;
(function (ImageOptionsPresetType) {
    ImageOptionsPresetType["Large"] = "LARGE";
    ImageOptionsPresetType["Medium"] = "MEDIUM";
    ImageOptionsPresetType["Small"] = "SMALL";
    ImageOptionsPresetType["Thumbnail"] = "THUMBNAIL";
})(ImageOptionsPresetType || (exports.ImageOptionsPresetType = ImageOptionsPresetType = {}));
var OmitMeasurementsOptionAdmin;
(function (OmitMeasurementsOptionAdmin) {
    /** Omit any auto-generated measurements text from the condition notes whether or not structured measurements collection is enabled for check-in. */
    OmitMeasurementsOptionAdmin["Always"] = "ALWAYS";
    /** Return the notes including any measurements text generated automatically at check-in time. */
    OmitMeasurementsOptionAdmin["Never"] = "NEVER";
    /** Omit any auto-generated measurements text from the condition notes provided structured measurements collection is enabled for check-in. */
    OmitMeasurementsOptionAdmin["WhenMeasurementsEnabledForCheckin"] = "WHEN_MEASUREMENTS_ENABLED_FOR_CHECKIN";
})(OmitMeasurementsOptionAdmin || (exports.OmitMeasurementsOptionAdmin = OmitMeasurementsOptionAdmin = {}));
var OmitMeasurementsOptionPrivate;
(function (OmitMeasurementsOptionPrivate) {
    /** Omit any auto-generated measurements text from the condition notes whether or not structured measurements collection is enabled for check-in. */
    OmitMeasurementsOptionPrivate["Always"] = "ALWAYS";
    /** Return the notes including any measurements text generated automatically at check-in time. */
    OmitMeasurementsOptionPrivate["Never"] = "NEVER";
    /** Omit any auto-generated measurements text from the condition notes provided structured measurements collection is enabled for check-in. */
    OmitMeasurementsOptionPrivate["WhenMeasurementsEnabledForCheckin"] = "WHEN_MEASUREMENTS_ENABLED_FOR_CHECKIN";
})(OmitMeasurementsOptionPrivate || (exports.OmitMeasurementsOptionPrivate = OmitMeasurementsOptionPrivate = {}));
var PricingAdjustmentStagingItemvalidationStatusEnumType;
(function (PricingAdjustmentStagingItemvalidationStatusEnumType) {
    PricingAdjustmentStagingItemvalidationStatusEnumType["Error"] = "error";
    PricingAdjustmentStagingItemvalidationStatusEnumType["Valid"] = "valid";
    PricingAdjustmentStagingItemvalidationStatusEnumType["Warning"] = "warning";
})(PricingAdjustmentStagingItemvalidationStatusEnumType || (exports.PricingAdjustmentStagingItemvalidationStatusEnumType = PricingAdjustmentStagingItemvalidationStatusEnumType = {}));
var ReturnItemState;
(function (ReturnItemState) {
    ReturnItemState["Deleted"] = "DELETED";
    ReturnItemState["Expected"] = "EXPECTED";
    ReturnItemState["ExtraItem"] = "EXTRA_ITEM";
    ReturnItemState["Missing"] = "MISSING";
    ReturnItemState["Processed"] = "PROCESSED";
})(ReturnItemState || (exports.ReturnItemState = ReturnItemState = {}));
var SignInMethodPublic;
(function (SignInMethodPublic) {
    SignInMethodPublic["MagicLink"] = "MAGIC_LINK";
    SignInMethodPublic["Sso"] = "SSO";
})(SignInMethodPublic || (exports.SignInMethodPublic = SignInMethodPublic = {}));
var SimOrderStageTypeEnum;
(function (SimOrderStageTypeEnum) {
    /** creates order */
    SimOrderStageTypeEnum["Create"] = "create";
    /** delivers order package (and all previous steps) */
    SimOrderStageTypeEnum["Deliver"] = "deliver";
    /** sets dimension for order package (and all previous steps) */
    SimOrderStageTypeEnum["Dimension"] = "dimension";
    /** fulfills order package (and all previous steps) */
    SimOrderStageTypeEnum["Fulfill"] = "fulfill";
    /** packs order (and all previous steps) */
    SimOrderStageTypeEnum["Pack"] = "pack";
    /** picks order (and all previous steps) */
    SimOrderStageTypeEnum["Pick"] = "pick";
    /** purchases postage for order package (and all previous steps) */
    SimOrderStageTypeEnum["Postage"] = "postage";
})(SimOrderStageTypeEnum || (exports.SimOrderStageTypeEnum = SimOrderStageTypeEnum = {}));
var SimTransferTypeEnum;
(function (SimTransferTypeEnum) {
    /** completes a transfer */
    SimTransferTypeEnum["Complete"] = "complete";
    /** creates a transfer */
    SimTransferTypeEnum["Create"] = "create";
    /** receives a transfer */
    SimTransferTypeEnum["Receive"] = "receive";
})(SimTransferTypeEnum || (exports.SimTransferTypeEnum = SimTransferTypeEnum = {}));
var TrackedEventappNameEnumType;
(function (TrackedEventappNameEnumType) {
    TrackedEventappNameEnumType["CatalogBuilder"] = "catalogBuilder";
    TrackedEventappNameEnumType["ItemIdentification"] = "itemIdentification";
    TrackedEventappNameEnumType["ItemInspection"] = "itemInspection";
    TrackedEventappNameEnumType["Move"] = "move";
})(TrackedEventappNameEnumType || (exports.TrackedEventappNameEnumType = TrackedEventappNameEnumType = {}));
var TradeinSourceCommerce;
(function (TradeinSourceCommerce) {
    /** Indicates the trade-in was created externally, e.g., via a third-party integration or partner system. */
    TradeinSourceCommerce["External"] = "EXTERNAL";
    /** Indicates the trade-in was created internally. */
    TradeinSourceCommerce["Trove"] = "TROVE";
})(TradeinSourceCommerce || (exports.TradeinSourceCommerce = TradeinSourceCommerce = {}));
var VasTaskInputStatusTypeEnum;
(function (VasTaskInputStatusTypeEnum) {
    VasTaskInputStatusTypeEnum["Completed"] = "completed";
    VasTaskInputStatusTypeEnum["Failed"] = "failed";
    VasTaskInputStatusTypeEnum["Notneeded"] = "notneeded";
    VasTaskInputStatusTypeEnum["Pending"] = "pending";
    VasTaskInputStatusTypeEnum["Progress"] = "progress";
})(VasTaskInputStatusTypeEnum || (exports.VasTaskInputStatusTypeEnum = VasTaskInputStatusTypeEnum = {}));
var WorkflowType;
(function (WorkflowType) {
    WorkflowType["ItemInspection"] = "ITEM_INSPECTION";
    WorkflowType["Refurbishment"] = "REFURBISHMENT";
})(WorkflowType || (exports.WorkflowType = WorkflowType = {}));
var WorkflowVersionstateEnumType;
(function (WorkflowVersionstateEnumType) {
    WorkflowVersionstateEnumType["Active"] = "ACTIVE";
    WorkflowVersionstateEnumType["Archived"] = "ARCHIVED";
    WorkflowVersionstateEnumType["Draft"] = "DRAFT";
})(WorkflowVersionstateEnumType || (exports.WorkflowVersionstateEnumType = WorkflowVersionstateEnumType = {}));
//# sourceMappingURL=rewarePublicTypes.js.map